<template>
  <div>
    <div class="service-h-mobile-box">
      <div class="d-flex sh-mobile-row">
        <div class="sh-mobile-field">
          <label>Pickup Address</label>
          <div>{{ pickup.loc.title }}</div>
        </div>
        <div class="sh-mobile-field">
          <label>Dropoff Address</label>
          <div>{{ dropoff.loc.title }}</div>
        </div>
      </div>

      <div class="d-flex sh-mobile-row">
        <div class="sh-mobile-field">
          <label>Departure Airport</label>
          <div>{{ pickup.airport }} Airport</div>
        </div>
        <div class="sh-mobile-field">
          <label>Arrival Airport</label>
          <div>{{ dropoff.airport }} Airport</div>
        </div>
      </div>

      <div class="d-flex sh-mobile-row date-pax">
        <div class="sh-mobile-field">
          <div>
            {{ dateLabel(flightDate.departure) }}
            <span v-if="tripType === 'roundtrip'"> - {{ dateLabel(flightDate.arrival) }}</span>
          </div>
        </div>
        <div class="sh-mobile-field">
          <div>{{ pax.total }} Traveler(s)</div>
        </div>
      </div>

      <div class="lr-btn edit-btn" @click="showEdit = true">Edit</div>
    </div>

    <div :class="['service-h-box', {show:showEdit}]">
      <div class="trip-type">
        <label>
          <input type="radio" name="triptype" value="roundtrip" v-model="tripType" />
          Roundtrip
        </label>
        <label>
          <input type="radio" name="triptype" value="oneway" v-model="tripType" />
          One-way
        </label>
        <div class="sh-box-close" @click="showEdit = false">
          <i class="fas fa-times"></i>
        </div>
      </div>
  
      <div class="ride-details-box d-flex">
        <div class="rd-loc-box">
          <div :class="['rd-field-box', {'has-error':validation.pickup}]">
            <label>Pickup Address</label>
            <!-- <input type="text" class="rd-txt" /> -->
            <location-input :value="pickup.loc.title" :extra="pickupExtra" ref="pickup"
              :disabled="groundQuoteLoading.pickup" leg="leg1"
              :noCommit="true"
              @change="locationNewValue"
              @isAirportVal="isAirportVal" @locationVal="locationVal"
            ></location-input>
            <!-- @airportSortListVal="airportSortListVal" -->
          </div>
          <div :class="['rd-field-box', {'has-error':validation.pickupAirport, 'no-hover':pickup.isAirport}]">
            <label><span class="hide-label">Recommended </span>departure airport</label>
            <select v-model="pickup.airport" @change="updateAirport('pickup')" :disabled="pickup.isAirport">
              <option v-for="(a, i) in pickup.nearByAirports" :value="a.airport.code" :key="i">{{a.airport.name}}</option>
            </select>
          </div>
        </div>
  
        <div class="rd-field-box reverse-loc no-hover">
          <i class="fas fa-exchange-alt" @click="reverseLoc"></i>
        </div>
  
        <div class="rd-loc-box">
          <div :class="['rd-field-box', {'has-error':validation.dropoff}]">
            <label>Dropoff Address</label>
            <!-- <input type="text" class="rd-txt" /> -->
             <location-input :value="dropoff.loc.title" :extra="dropoffExtra" ref="dropoff"
              :disabled="groundQuoteLoading.dropoff" leg="leg1"
              :noCommit="true"
              @change="locationNewValue"
              @isAirportVal="isAirportVal" @locationVal="locationVal"
            ></location-input>
          </div>
          <div :class="['rd-field-box', {'has-error':validation.dropoffAirport, 'no-hover':dropoff.isAirport}]" >
            <label><span class="hide-label">Recommended </span>arrival airport</label>
            <select v-model="dropoff.airport" @change="updateAirport('dropoff')" :disabled="dropoff.isAirport">
              <option v-for="(a, i) in dropoff.nearByAirports" :value="a.airport.code" :key="i">{{a.airport.name}}</option>
            </select>
          </div>
        </div>
  
        <div>
          <div class="rd-field-box date-pax" @click="openDeparturePicker">
            <label>
              Departing 
              <div v-if="tripType === 'roundtrip'">- Arrival Date</div>
            </label>
            <div class="div-val">
              <i class="far fa-calendar-alt"></i>
              <span>{{ dateLabel(flightDate.departure) }}</span>
              <span v-if="tripType === 'roundtrip'"> - {{ dateLabel(flightDate.arrival) }}</span>
            </div>
          </div>
          
          <div class="rd-field-box date-pax" @click="openTravellersModal">
            <label>&nbsp;</label>
            <div class="div-val">
              <i class="far fa-user"></i>
              <span>{{ pax.total }} Traveler(s)</span>
            </div>
          </div>
        </div>
  
        <div>
          <div class="rd-field-box">
            <label>Cabin Class</label>
            <select v-model="minCabin" class="min-cabin">
              <option v-for="(cabin, i) in booking.cabinList" :key="i" :value="cabin">{{ cabinLabel(cabin) }}</option>
            </select>
          </div>
          <div :class="['lr-btn edit-btn', hasUpdate ? 'highlight' : 'disabled']" @click="submit">Search</div>
        </div>
      </div>

      <transition name="slide-down" mode="out-in">
        <div class="press-search" v-show="hasUpdate">
          <i class="fas fa-info-circle"></i>
          Press "Search" button to apply new changes
        </div>
      </transition>
    </div>

    <departure-modal :noCommit="true" @dateVal="dateVal" :isRt="tripType === 'roundtrip'"></departure-modal>
    <travellers-modal :noCommit="true" @travelersVal="travelersVal"></travellers-modal>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment-timezone'
import LocationInput from '@/components/Search/LocationInput'
import DepartureModal from '@/components/Search/DateTimePicker'
import TravellersModal from '@/components/Search/TravellersModal'
import ApiQuote from '@/modules/api/quote'
import booking from '@/modules/api/booking'
import trackError from '@/modules/api/track-error'

export default {
  components: { LocationInput, DepartureModal, TravellersModal },
  data () {
    return {
      tripType: 'roundtrip',
      pickup: {
        loc: {},
        airport: '',
        isAirport: false,
        nearByAirports: []
      },
      dropoff: {
        loc: {},
        airport: '',
        isAirport: false,
        nearByAirports: []
      },
      pickupText: '',
      dropoffText: '',
      flightDate: {
        departure: '',
        arrival: ''
      },
      pax: {
        total: 1,
        adult: 1,
        children: 0,
        infants: 0
      },
      minCabin: 'Economy',
      groundQuoteLoading: {
        pickup: false,
        dropoff: false
      },
      validation: {
        pickup: '',
        pickupAirport: '',
        dropoff: '',
        dropoffAirport: '',
        date: ''
      },
      tmpStore: {
        pickup: '',
        dropoff: '',
        airportPickup: '',
        airportDropoff: '',
        airportSort: '',
        departure: '',
        travellers: ''
      },
      showEdit: false,
      origValue: {
        isRoundtrip: false,
        pickup: '',
        pickupAirport: '',
        dropoff: '',
        dropoffAirport: '',
        departDate: '',
        arrivalDate: '',
        pax: 1,
        minCabin: 'Economy'
      },
      hasUpdate: false,
      internationalCheckList: []
    }
  },
  computed: {
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    isReturning () { return this.filters.departure.isReturning },
    other () { return this.$store.state.other },
    pickupExtra () {
      return {
        field: 'pickup',
        // placeholder: 'Enter your pickup location',
        placeholder: 'Enter your Pickup Address i.e. Home, Airport etc',
        flightInput: true
      }
    },
    dropoffExtra () {
      return {
        field: 'dropoff',
        // placeholder: 'Enter your Dropoff location',
        placeholder: 'Enter your Destination Address i.e. Home, Airport etc',
        flightInput: true
        // error: this.validation.dropoff
      }
    },
    rsvpData () { return this.$store.state.reservation },
    extraStop () { return this.rsvpData.extraStop },
    mtech () { return this.rsvpData.mtech },
    apiType () { return this.booking.apiType },
    settings () { return this.booking.settings }
  },
  methods: {
    locationNewValue (val) {
      if (val.field === 'pickup') this.pickupText = val.keyInput
      else this.dropoffText = val.keyInput
      this.checkForChange()
    },
    isAirportVal (val) {
      let self = this
      let tmp = val.field === 'pickup' ? 'airportPickup' : 'airportDropoff'
      self.tmpStore[tmp] = val.data
      self[val.field].isAirport = val.data.value
      // if (!val.data.value) {
      self.groundQuoteLoading[val.field] = true
      setTimeout(() => {
        self.checkNearestAirport(val.field, false, val.data.value)
      }, 100)
      // }
    },
    locationVal (val) {
      this.tmpStore[val.field] = val.data
      if (val.data.value) this[val.field].loc = val.data.value
    },
    checkNearestAirport (field, saveList = true, updateAirport = false) {
      let self = this
      let loc = self[field].loc
      let coord1 = {
        lat: loc.lat,
        lng: loc.lng
      }
      let nearest = {
        airport: {},
        distance: ''
      }
      let tmpList = []
      self.booking.airports.forEach((x, i) => {
        let currentDistance = self.getDistance(coord1, {lat: x.lat, lng: x.lng})
        if (!nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        } else if (currentDistance < nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        }
        if (currentDistance <= self.settings.nearByAirportMilesLimit) {
          tmpList.push({
            airport: self.booking.airports[i],
            distance: currentDistance
          })
        }
      })
      tmpList.sort((a, b) => {
        return a.distance - b.distance
      })

      this[field].nearByAirports = tmpList
      this.groundQuoteLoading[field] = false
      let lookUp = tmpList.findIndex(x => x.airport.code === this[field].airport)
      if (lookUp === -1 || updateAirport) this[field].airport = tmpList[0].airport.code

      if (saveList) {
        let tmp = {}
        tmp[field] = tmpList
        self.$store.commit('booking/setNearyByAirports', tmp)
      }
      if (!tmpList.length) {
        trackError.track(self, {
          type: 'no_nearby_airport',
          data: {
            main_pickup: self.locations.pickup,
            main_dropoff: self.locations.dropoff,
            request: '',
            response: '',
            target: loc,
            D2DAirportDistanceLimitMiles: self.settings.nearByAirportMilesLimit
          }
        })
        self.d2dQueue = []
        self.$store.commit('global/setAlertData', {show: true, message: `Out of Coverage Area, We're working hard to cover your ${field} location soon.`})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      if (saveList && !updateAirport) {
        let data = {}
        // data[`${field}Airport`] = nearest.airport
        data[`${field}Airport`] = tmpList[lookUp].airport
        let reverseType = field === 'pickup' ? 'dropoff' : 'pickup'
        // data[`${reverseType}AirportReturn`] = nearest.airport
        data[`${reverseType}AirportReturn`] = tmpList[lookUp].airport
        // self.$store.commit('booking/setLocationsData', data)
        self.checkGroundQuote(field, data[`${field}Airport`])
      }
    },
    getDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let distance = R * c
      return distance / 1.609344
    },
    updateAirport (type) {
      // let data = {}
      let i = this.booking.nearByAirports[type].findIndex(x => x.airport.code === this[type].airport)
      if (i === -1) {
        console.log('Airport NOT FOUND!')
        return
      }
      // data[`${type}Airport`] = this.booking.nearByAirports[type][i].airport
      // let reverseType = type === 'pickup' ? 'dropoff' : 'pickup'
      // data[`${reverseType}AirportReturn`] = data[`${type}Airport`]
      // this.$store.commit('booking/setLocationsData', data)

      this.$store.commit('booking/setOthersData', {fetch: [...this.booking.cabinList]})
      this.checkForChange()
      // if (window.gtag) { // eslint-disable-line
      //   let eventName = type === 'pickup' ? 'D2Dservice - Departure Airport' : 'D2Dservice - Arrival Airport'
      //   gtag( // eslint-disable-line
      //     'event',
      //     eventName,
      //     {value: data.name}
      //   )
      // }
    },
    reverseLoc () {
      let tmp = this.cleanCopy(this.dropoff)
      let tmpText = this.dropoffText
      this.dropoff = this.pickup
      this.dropoffText = this.pickupText
      this.pickup = tmp
      this.pickupText = tmpText
      this.checkForChange()
    },
    dateLabel (x) {
      return x ? moment(x, 'MM/DD/YYYY').format('MMM DD') : x
    },
    openDeparturePicker () {
      this.$store.commit('booking/setDepartureData', {show: true})
    },
    dateVal (val) {
      this.tmpStore.departure = val
      this.flightDate.departure = val.date
      if (val.isReturning) this.flightDate.arrival = val.return
      this.tripType = val.isReturning ? 'roundtrip' : 'oneway'
      this.checkForChange()
    },
    openTravellersModal () {
      this.$store.commit('booking/setTravellersData', {show: true})
    },
    travelersVal (val) {
      this.pax = val
      this.checkForChange()
    },
    cleanCopy (x) {
      return JSON.parse(JSON.stringify(x))
    },
    submit () {
      let self = this

      self.validation.pickup = ''
      self.validation.pickupAirport = ''
      self.validation.dropoff = ''
      self.validation.dropoffAirport = ''
      self.validation.date = ''
      let hasError = false

      if (self.pickupText.trim() === '') {
        hasError = true
        self.validation.pickup = self.$t('common.fieldEmpty')
      }
      if (self.pickup.isAirport && !self.pickup.airport) {
        hasError = true
        self.validation.pickupAirport = self.$t('common.fieldEmpty')
      }

      if (self.dropoffText.trim() === '') {
        hasError = true
        self.validation.dropoff = self.$t('common.fieldEmpty')
      }
      if (self.dropoff.isAirport && !self.dropoff.airport) {
        hasError = true
        self.validation.dropoffAirport = self.$t('common.fieldEmpty')
      }

      if (self.pickupText && self.dropoffText && self.pickupText === self.dropoffText) {
        hasError = true
        self.validation.dropoff = 'Please select a different dropoff location.'
      }

      if (hasError) return

      let tmpPickupObj = {
        pickup: this.pickup.loc,
        isAirportPickup: this.pickup.isAirport,
        dropoff: this.dropoff.loc,
        isAirportDropoff: this.dropoff.isAirport
      }
      let pickupAirportIndex = this.pickup.nearByAirports.findIndex(x => x.airport.code === this.pickup.airport)
      if (pickupAirportIndex > -1) {
        let pickupAirport = this.pickup.nearByAirports[pickupAirportIndex].airport
        tmpPickupObj.pickupAirport = pickupAirport
        tmpPickupObj.dropoffAirportReturn = pickupAirport
      }
      let dropoffAirportIndex = this.dropoff.nearByAirports.findIndex(x => x.airport.code === this.dropoff.airport)
      if (dropoffAirportIndex > -1) {
        let dropoffAirport = this.dropoff.nearByAirports[dropoffAirportIndex].airport
        tmpPickupObj.dropoffAirport = dropoffAirport
        tmpPickupObj.pickupAirportReturn = dropoffAirport
      }
      this.$store.commit('booking/setLocationsData', tmpPickupObj)
      this.$store.commit('booking/setFlightLocationsData', {
        pickup: tmpPickupObj.pickupAirport,
        dropoff: tmpPickupObj.dropoffAirport
      })
      this.$store.commit('booking/setNearyByAirports', {
        pickup: this.pickup.nearByAirports,
        dropoff: this.dropoff.nearByAirports
      })

      this.$store.commit('booking/setDepartureData', {
        date: this.flightDate.departure,
        return: this.flightDate.arrival,
        isReturning: this.tripType === 'roundtrip'
      })
      this.$store.commit('booking/setTravellersData', this.pax)
      this.$store.commit('booking/setOthersData', {minCabin: this.minCabin})

      if (this.tmpStore.airportSort) this.$store.commit('airports/sortList', this.tmpStore.airportSort)

      self.showEdit = false
      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: ''
      })

      self.d2dQueue = []
      // if (self.other.widgetTab === 'd2d') self.d2dQueue = ['checkPickupDropoffDistance', 'checkGroundQuotePickup', 'checkGroundQuoteDropoff']
      if (self.other.widgetTab === 'd2d') self.d2dQueue = ['checkPickupDropoffDistance', 'pickupNearestAirport', 'dropoffNearestAirport', 'checkInternationalAirport']
      // ['checkPickupDropoffDistance', 'getAirports', 'pickupNearestAirport', 'dropoffNearestAirport']
      self.d2dQueue.push('getFlight')
      self.show = false

      // Reset Selected Flights
      self.$store.commit('booking/setSelectedData', {leg1: {}, leg2: {}})
      self.$store.commit('booking/setOthersData', {activeLeg: 'leg1', servicesPage: 10})

      // Update Orig value
      let cc = this.cleanCopy
      this.origValue = {
        isRoundtrip: cc(this.tripType),
        pickup: cc(this.pickupText),
        pickupAirport: cc(this.pickup.airport),
        dropoff: cc(this.dropoffText),
        dropoffAirport: cc(this.dropoff.airport),
        departDate: cc(this.flightDate.departure),
        arrivalDate: cc(this.flightDate.arrival),
        pax: cc(this.pax.total)
      }
      this.hasUpdate = false

      self.d2dProcess()
    },
    d2dProcess () {
      let self = this
      if (!self.d2dQueue.length) return
      if (self.d2dQueue[0] === 'checkPickupDropoffDistance') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Checking Locations...'})
        self.checkGroundQuote('check', {})
        return
      }
      if (self.d2dQueue[0] === 'getAirports') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Getting airport data...'})
        self.getAirportList()
        return
      }
      if (self.d2dQueue[0] === 'pickupNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('pickup')
        return
      }
      if (self.d2dQueue[0] === 'dropoffNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('dropoff')
        return
      }
      if (self.d2dQueue[0] === 'checkGroundQuotePickup') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Checking ground services...'})
        // self.checkGroundQuote('pickup', self.locations.pickupAirport)
        self.checkGroundQuote('pickup', self.pickup.airport)
        return
      }
      if (self.d2dQueue[0] === 'checkGroundQuoteDropoff') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Checking ground services...'})
        // self.checkGroundQuote('dropoff', self.locations.dropoffAirport)
        self.checkGroundQuote('dropoff', self.dropoff.airport)
        return
      }
      if (self.d2dQueue[0] === 'checkInternationalAirport') {
        let pickupAirports = []
        self.booking.nearByAirports.pickup.forEach(x => { pickupAirports.push(x.airport.code) })
        let dropoffpAirports = []
        self.booking.nearByAirports.dropoff.forEach(x => { dropoffpAirports.push(x.airport.code) })
        self.internationalCheckList = [
          {
            location: self.locations.pickup.title,
            airports: pickupAirports
          },
          {
            location: self.locations.dropoff.title,
            airports: dropoffpAirports
          }
        ]
        self.checkInternationalAirport()
        return
      }
      if (self.d2dQueue[0] === 'getFlight') {
        self.$store.commit('other/setOtherData', {
          appLoaderMsg: 'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
          useLoadingMsg: true
        })

        let pickup = self.locations.pickup
        let dropoff = self.locations.dropoff
        let isIndia = pickup.country === 'IND' && dropoff.country === 'IND'
        self.$store.commit('booking/setSettingsData', {customFlight: isIndia})

        let cabins = [...self.booking.cabinList]
        let tmp = {}
        tmp.loading = []
        // tmp.selectedCabin = 'Economy'
        self.$store.commit('booking/setAirlinesLegData', {leg: 'leg1', fields: tmp})
        setTimeout(() => {
          if (self.apiType === 'API1') {
            cabins.forEach(cabin => {
              self.getFlightQuote(cabin, 'leg1')
              if (self.isReturning) self.getFlightQuote(cabin, 'leg2')
            })
          } else {
            cabins = cabins.splice(cabins.indexOf(self.minCabin))
            self.getFlightQuote(cabins, 'leg1')
            if (self.isReturning && self.settings.customFlight) self.getFlightQuote(cabins, 'leg2')
          }
        }, 50)
      }
    },
    checkGroundQuote (type, airport) {
      let self = this
      let pickupDate = moment(self.filters.departure.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        pickupDate: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        order: 'priority',
        asap: false,
        d2dflight: 1
      }
      let origin = type === 'pickup' ? self.locations.pickup : airport
      let destination = type === 'pickup' ? airport : self.locations.dropoff
      if (type === 'check') {
        origin = self.locations.pickup
        destination = self.locations.dropoff
      }
      // quoteData.pickup = { lat: origin.lat, lng: origin.lng }
      // quoteData.dropoff = { lat: destination.lat, lng: destination.lng }
      quoteData.pickup = origin
      quoteData.dropoff = destination

      let usa = ['us', 'usa', 'united states', 'united states of america']
      let canada = ['can', 'ca', 'canada']
      let ca = ['ca', 'california']
      if (type !== 'check' &&
        (
          (quoteData.pickup.country && usa.indexOf(quoteData.pickup.country.toLowerCase()) > -1 &&
          quoteData.pickup.state && ca.indexOf(quoteData.pickup.state.toLowerCase()) === -1) ||
          (quoteData.pickup.country && canada.indexOf(quoteData.pickup.country.toLowerCase()) > -1)
        )
      ) {
        self.lyftQuoteCheck(type, airport, quoteData)
        return
      }

      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, r => {
        self.sendQuoteTime(timeNow, moment(), r.quoteId, quoteData)
        if (r.error && type !== 'check') {
          let xCountry = quoteData.pickup.country || quoteData.dropoff.country
          if (
            (xCountry && usa.indexOf(xCountry.toLowerCase()) > -1) ||
            (xCountry && canada.indexOf(xCountry.toLowerCase()) > -1)
          ) {
            self.lyftQuoteCheck(type, airport, quoteData)
            return
          }
          // self.lyftQuoteCheck(type, airport, quoteData)
          self.show = true
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: `Out of Coverage Area, We're working hard to cover your pickup/drop-off location soon.`})
          trackError.track(self, {
            type: 'ground_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                route: '/quotation',
                payload: quoteData
              },
              response: r
            }
          })
          return
        }
        if (!r.error && type === 'check') {
          if (r.route.distance <= self.settings.forceGroundMiles) {
            self.$store.commit('reservation/setPickup', {leg: 'leg1', value: self.locations.pickup})
            self.$store.commit('reservation/setDropoff', {leg: 'leg1', value: self.locations.dropoff})
            self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg1', value: false})
            self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg1', value: false})
            self.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })
            let timeNow = moment()
            let div5 = timeNow.minutes() % 5
            timeNow = timeNow.subtract(div5, 'minutes')
            self.$store.commit('reservation/setPickupDate', { leg: 'leg1', value: `${self.filters.departure.date} ${timeNow.format('hh:mmA')}` })
            self.$store.commit('serviceSelection/setForPickupDate', false)
            let roundttrip = self.filters.departure.isReturning
            self.$store.commit('reservation/setIsRoundtrip', roundttrip)
            if (roundttrip) {
              self.$store.commit('reservation/setRtPricing', true)
              self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg2', value: false})
              self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg2', value: false})
              self.$store.commit('reservation/setPickupDate', { leg: 'leg2', value: `${self.filters.departure.return} ${timeNow.format('hh:mmA')}` })
            }
            self.getGroundQuote()
            return
          }
        }

        if (
          !r.error && type !== 'check' && !airport && r.geofences &&
          (ca.indexOf(quoteData.pickup.state.toLowerCase()) === -1 ||
          (ca.indexOf(quoteData.pickup.state.toLowerCase()) > -1 && !r.geofences.servicearea.name.includes('LAX')))
        ) {
          self.lyftQuoteCheck(type, airport, quoteData)
          return
        }
        self.d2dQueue.shift()
        self.d2dProcess()
      }, '2.0')
    },
    lyftQuoteCheck (type, airport, param) {
      let self = this
      let newParam = {
        brandId: param.brandId,
        pickup: param.pickup,
        dropoff: param.dropoff,
        pickupTime: moment(param.pickupDate, 'YYYY-MM-DD').format('X'),
        leg: param.leg
      }

      self.$sdk.post(self, '/quotation/lyft/future', newParam, res => {
        if (res.lyft) {
          let hasService = false
          res.lyft.forEach(x => {
            if (x.can_request_ride) hasService = true
          })
          if (!hasService) res.lyft = []
        }
        if (!res.lyft.length) {
          self.show = true
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: `Out of Coverage Area, We're working hard to cover your pickup/drop-off location soon.`})
          trackError.track(self, {
            type: 'ground_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                route: '/quotation/lyft/future',
                payload: newParam
              },
              response: res
            }
          })
          return
        }
        self.d2dQueue.shift()
        self.d2dProcess()
      }, '2.0')
    },
    getAirportList () {
      let self = this
      if (self.booking.airports.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.get(self, '/airport', {}, r => {
        let airports = []
        if (r.list) {
          r.list.forEach(data => {
            airports.push({
              name: data.name,
              code: data.code,
              address1: data.addressLine1,
              address2: data.addressLine2,
              city: data.city,
              state: data.state,
              zip: data.zipCode,
              country: data.country,
              lat: data.lat,
              lng: data.lng
            })
          })
        }
        self.$store.commit('booking/setAirportData', {airports: airports})
        setTimeout(function () {
          self.d2dQueue.shift()
          self.d2dProcess()
        }, 200)
      }, '2.0')
    },
    checkInternationalAirport () {
      let self = this

      if (!self.internationalCheckList.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.post2(`${CONFIG.d2dAPI}/api/airports`, {
        code: self.internationalCheckList[0].airports
      }, r => {
        if (r.success) {
          // let tmp = {}
          // tmp[self.internationalCheckList[0].location] = r.airports[0]
          self.$store.commit('booking/setInternationalAirport', {
            location: self.internationalCheckList[0].location,
            code: r.airports[0]
            // field: 'international',
            // val: tmp
          })
        }
        self.internationalCheckList.shift()
        self.checkInternationalAirport()
      })
    },
    getFlightQuote (cabin, leg) {
      let self = this
      let tmpCabin = (typeof cabin === 'object') ? 'API2' : cabin

      if (self.booking.airlines[leg].loading.indexOf(tmpCabin) > -1) return
      self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})

      let locations = self.locations
      if (self.other.widgetTab === 'flight') locations = locations.flight

      // Reset Airlines Data - By Cabin
      booking.resetAirlineData(self, cabin, leg)

      let params = booking.flightParam(self, cabin, leg)
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        try {
          if (
            r === null || !Object.keys(r).length || r.code === 'ETIMEDOUT' ||
            (r.error && ['No flight data found for any cabin search type.', 'No flight data found in the response.'].indexOf(r.error) > -1)
          ) {
            self.$store.commit('global/setAlertData', {show: true, message: `No flights found for the specified location. Please try again later or verify the location entered.`})
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: locations.pickup,
                main_dropoff: locations.dropoff,
                // request: params,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            return
          }

          if (r.code === 'ERR_BAD_RESPONSE') {
            self.$store.commit('global/setAlertData', {show: true, message: `Oops! Something went wrong. Please try again later. `})
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: locations.pickup,
                main_dropoff: locations.dropoff,
                // request: params,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            return
          }

          let tmpStoredData = {leg: leg, fields: {}}
          tmpStoredData.fields[tmpCabin] = r
          self.$store.commit('global/setStoredFlightData', tmpStoredData)

          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            let flightData = booking.buildFlightData(self, r, cabin, leg)

            // Save Flight List
            if (self.apiType === 'API1') {
              let tmpAirlineLegData = {leg: leg, fields: {}}
              tmpAirlineLegData.fields[tmpCabin] = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
            } else if (Object.keys(flightData.cabinFlights).length) {
              for (var key in flightData.cabinFlights) {
                let tmpAirlineLegData = {leg: leg, fields: {}}
                tmpAirlineLegData.fields[key] = flightData.cabinFlights[key]
                self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
              }

              let tmpUniqueFlight = {leg: leg, fields: {API2: []}}
              for (var key2 in flightData.uniqueFlights) {
                tmpUniqueFlight.fields.API2.push(flightData.uniqueFlights[key2])
              }
              tmpUniqueFlight.fields.API2Raw = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpUniqueFlight)
            }

            // Save Airline Unique
            let tmpAirlineUnique = {}
            tmpAirlineUnique[tmpCabin] = flightData.airlinesUnique
            self.$store.commit('booking/setAirlinesUniqueLegData', {
              leg: leg,
              fields: tmpAirlineUnique
            })

            if (self.lastPickup !== self._pickup || self.lastDropoff !== self._dropoff) {
              // Setup: Opt-in Ground Booking
              let includedLandTranspo = self.d2d.departure.isReturning ? [0, 1, 2, 3] : [0, 1]
              self.$store.commit('booking/setOthersData', {includedLandTranspo: includedLandTranspo})
            }

            self.$store.commit('other/setOtherData', {
              appLoader: false,
              appLoaderMsg: ''
            })
            self.setupPax()
            if (self.other.widgetTab === 'd2d') {
              localStorage.removeItem('lastPickupLoc')
              localStorage.removeItem('lastDropoffLoc')
              localStorage.setItem('lastPickupLoc', JSON.stringify(locations.pickup))
              localStorage.setItem('lastDropoffLoc', JSON.stringify(locations.dropoff))
            }
            self.$store.commit('reservation/setOtherData', {bookingType: 'flight'})

            let tmpApplyFilter = {leg: leg, fields: {}}
            tmpApplyFilter.fields[tmpCabin] = true
            self.$store.commit('booking/setApplyFilter', tmpApplyFilter)
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
          }
        } catch (error) {
          self.$store.commit('other/setOtherData', {
            appLoader: false,
            appLoaderMsg: ''
          })
          self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
          self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please adjust your search and try again.'})
          let locations = self.other.widgetTab === 'flight' ? self.locations.flight : self.locations
          locations = locations.flight
          trackError.track(self, {
            type: 'flight_booking',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
        }
      })
    },
    getGroundQuote () {
      let self = this

      this.timezoneLoading = true
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      let pickup = this.rsvpData.leg1.pickup
      url = url.replace('{AT}', encodeURIComponent(pickup.lat + ',' + pickup.lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        // Default to LA
        self.$store.commit('reservation/setTimezone', { leg: 'leg1', value: 'America/Los_Angeles' })
        if (err) { console.log(err) }
        self.timezoneLoading = false
        if (body.items.length) {
          self.$store.commit('reservation/setTimezone', {leg: 'leg1', value: body.items[0].timeZone.name})
        } else {
          console.log('Zero results on GET TIMEZONE')
        }
      })

      let pickupDate = this.rsvpData.leg1.pickupDate || this.rsvpData.leg1.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        date: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        asap: false
      }

      self.quoteErrorMsg = ''
      quoteData = {
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        order: 'priority',
        asap: false
      }
      quoteData.pickup = self.rsvpData.leg1.pickup
      quoteData.dropoff = self.rsvpData.leg1.dropoff
      self.extraStop.leg1.forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })

      ApiQuote.getQuote2(self, quoteData, res => {
        if (!res.error) {
          if (
            (!res.services.length && !res.mtech) ||
            (res.mtech && !res.mtech.services.length)
          ) {
            self.quoteErrorMsg = self.$t('searchForm.noAvailableService')
            return
          }
          if (res.mtech && self.extraStop.leg1.length) {
            self.quoteErrorMsg = self.$t('searchForm.serviceNA')
            return
          }
          // if (res.geofences.pickup.type === 'airport' || res.geofences.dropoff.type === 'airport') {
          //   self.getAirlineList()
          // }

          if (res.geofences.dropoff.type === 'airport') {
            self.$store.commit('reservation/setIsAirportPickup', {
              leg: 'leg2',
              value: true
            })
          }

          self.$store.commit('reservation/resetServiceEta')

          let serviceExist = false
          for (let service in res.services) {
            let serviceData = res.services[service]
            if (parseInt(self.rsvpData.leg1.selectedService.substr(1)) === serviceData.serviceType.id && !serviceData.unavailableTime) {
              serviceExist = true
            }
          }
          if (!serviceExist) {
            self.$store.commit('reservation/setSelectedService', {
              leg: 'leg1',
              value: ''
            })
          }

          // if (self.mtech.enabled && self.rsvpData.leg1.selectedService) {
          //   self.getQuoteMtechService()
          // }

          if (self.showOnLoad) {
            document.body.classList.add('widget-full')
          }

          self.$store.commit('reservation/setOtherData', {bookingType: 'ground'})
          self.$root.$router.push('service')
          window.location.href = '#/service'
        } else {
          self.quoteErrorMsg = res.error.message
          if (res.error.message === 'Services unavailable') {
            self.quoteErrorMsg = self.$t('searchForm.sorryService')
          }
        }
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
      this.$store.commit('booking/setOthersData', {servicesPage: 10})
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    checkForChange () {
      let hasChange = false
      if (
        this.origValue.isRoundtrip !== this.tripType ||
        this.origValue.pickup !== this.pickupText ||
        this.origValue.pickupAirport !== this.pickup.airport ||
        this.origValue.dropoff !== this.dropoffText ||
        this.origValue.dropoffAirport !== this.dropoff.airport ||
        this.origValue.departDate !== this.flightDate.departure ||
        this.origValue.arrivalDate !== this.flightDate.arrival ||
        this.origValue.pax !== this.pax.total ||
        this.origValue.minCabin !== this.minCabin
      ) hasChange = true
      this.hasUpdate = hasChange
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    }
  },
  watch: {
    tripType () { this.checkForChange() },
    hasUpdate (val) {
      this.$store.commit('booking/setOthersData', {serviceLegHighlight: !val})
    },
    minCabin () { this.checkForChange() }
  },
  mounted () {
    if (!this.booking.filters.departure.date) return

    let cc = this.cleanCopy
    this.tripType = this.isReturning ? 'roundtrip' : 'oneway'
    this.pickup.loc = cc(this.locations.pickup)
    this.pickupText = cc(this.locations.pickup.title)
    this.pickup.airport = cc(this.locations.pickupAirport.code)
    this.pickup.isAirport = this.locations.isAirportPickup
    this.pickup.nearByAirports = this.booking.nearByAirports.pickup

    this.dropoff.loc = cc(this.locations.dropoff)
    this.dropoffText = cc(this.locations.dropoff.title)
    this.dropoff.airport = cc(this.locations.dropoffAirport.code || '')
    this.dropoff.isAirport = this.locations.isAirportDropoff
    this.dropoff.nearByAirports = this.booking.nearByAirports.dropoff

    this.flightDate = {
      departure: cc(this.filters.departure.date),
      arrival: cc(this.filters.departure.return)
    }
    this.pax = cc(this.filters.travellers)
    this.minCabin = cc(this.booking.minCabin)

    this.origValue = {
      isRoundtrip: cc(this.tripType),
      pickup: cc(this.pickupText),
      pickupAirport: cc(this.pickup.airport),
      dropoff: cc(this.dropoffText),
      dropoffAirport: cc(this.dropoff.airport),
      departDate: cc(this.flightDate.departure),
      arrivalDate: cc(this.flightDate.arrival),
      pax: cc(this.pax.total),
      minCabin: cc(this.minCabin)
    }
  }
}
</script>

<style lang="scss" scoped>
.service-h-box{
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 3px 3px 3px -1px rgba(0, 0, 0, .1);
}

.trip-type{
  margin-bottom: 10px;
  label{
    margin-right: 20px;
    font-size: 15px;
    line-height: 1;
  }
  input{
    margin-right: 3px;
    vertical-align: -2px;
  }
  .sh-box-close{
    display: none;
  }
}

.ride-details-box{
  gap: 5px;
  align-items: start;

  .rd-loc-box{
    width: calc((100% - (53px + 190px))/2)
  }
  .rd-field-box{
    border: 2px solid #CCD0E2;
    border-radius: 4px;
    line-height: 1;
    padding: 7px 10px 10px;
    margin-bottom: 6px;

    &:not(.no-hover):hover{
      border-color: #d1b47c;
      box-shadow:0 0 3px rgba(0,0,0, .5);
    }
    label{
      display: block;
      color: #6c7c8f;
      font-size: 12px;
      letter-spacing: .5px;
      margin-bottom: 2px;
    }
    &.has-error{
      border-color: #e25a44;

      label{
        color: #e25a44;
      }
    }
  }
  .rd-txt, select{
    border: none;
    padding: 0;
    font-size: 18px;
    outline: none;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  select{
    margin-bottom: 0;
  }
  .reverse-loc{
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
    height:52px;

    &:hover{
      background: #fafafa;
    }
    i{
      font-size: 21px;
    }
  }
  .date-pax{
    width: 190px;
    label div{
      display: inline-block;
    }
    .div-val{
      height: 19px;
      // margin-top: 4px;
    }
    i{
      margin-right: 3px;
      color: #a0aebf;
    }
    span{
      font-size: 17px;
      display: inline-block;
    }
  }
  .edit-btn{
    font-size: 18px;
    padding: 18px 40px;

    &.highlight{
      opacity: 1;
      animation: glow .5s infinite alternate;
    }
  }
}
@keyframes glow {
  from { box-shadow: 0 0 2px -2px #f8cf71; }
  to { box-shadow: 0 0 2px 2px #efbb43; }
}
.press-search{
  font-style: italic;
  font-size: 13px;
  letter-spacing: .7px;
  color: #b1b1b1;
  display: block;
  margin-top: 5px;

  i{
    margin-right: 3px;
    color: #ff9c09;
  }
}

.service-h-mobile-box{
  display: none;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 3px 3px 3px -1px rgba(0, 0, 0, .1);
}
.sh-mobile-row{
  gap: 15px;
  margin-bottom: 15px;

  &.date-pax{
    margin: 25px 0 20px;
  }
}
.sh-mobile-field{
  width: 50%;
  line-height: 1;

  label{
    color: #5E6E7F;
    font-size: 13px;
    letter-spacing: .7px;
    display: block;
    margin-bottom: 5px;
  }
  div{
    color: #192024;
    font-size: 18px;
    letter-spacing: .5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.slide-down-enter-active,
.slide-down-leave-active{
  transition: all 150ms ease;
}
.slide-down-enter, .slide-down-leave-to{
  transform: translateY(-10px);
  opacity: 0;
}

@media only screen and (max-width: 639px) {
  .service-h-mobile-box{
    display: block;
  }
  .service-h-box{
    display: none;

    &.show{
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .trip-type{
      margin-bottom: 25px;

      label{
        margin-right:15px;
      }
    }
    .sh-box-close{
      display: block;
      float: right;

      i{
        font-size: 21px;
        color: #f72b2b;
        position: relative;
        bottom: 2px;
      }
    }
    .ride-details-box{
      flex-direction: column;
      gap: 10px;
    }
    .rd-loc-box{
      width: 100%;
      display: flex;
      gap: 10px;

      .rd-field-box{
        width: 50%;

        label{
          text-transform: capitalize;
          letter-spacing: .7px;
        }
      }
      .hide-label{
        display: none;
      }
    }
    .reverse-loc{
      width: 100%;
      background: #3e96ff;
      border-color: #0356b7;
      color: #fff;
      justify-content: center;
      box-shadow: 3px 3px 3px -2px rgba(0, 0, 0, .3);

      i{
        transform: rotate(90deg);
      }
    }
    .date-pax, .edit-btn{
      width: 100%
    }
  }
}
</style>


// WEBPACK FOOTER //
// ServiceHeader.vue?39256aa8